import { render, staticRenderFns } from "./DiscussionDownloadList.vue?vue&type=template&id=5211f9db&scoped=true"
import script from "./DiscussionDownloadList.vue?vue&type=script&lang=js"
export * from "./DiscussionDownloadList.vue?vue&type=script&lang=js"
import style0 from "./DiscussionDownloadList.vue?vue&type=style&index=0&id=5211f9db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5211f9db",
  null
  
)

export default component.exports